<div class="min-h-screen max-w-320 mx-auto py-8 px-4 sm:px-8 sm:py-16">

    <div class="grid grid-cols-2">
        <div class="col-span-2 md:col-span-1 max-w-100 w-full mx-auto">

           
            <h3 class="text-4xl font-medium">Log in</h3>
            <p class="mb-3">Log in to your <b>Markout Pro</b> account</p>

            <login></login>

            <div class="max-w-90 my-8">
                <button color="primary" mat-button [routerLink]="'/register'">
                    Create an account
                    <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:chevron-right'"></mat-icon>
                </button> 
                <br/>
                <button color="primary" mat-button [routerLink]="'/forgot-password'">
                    Forgot password?
                    <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:chevron-right'"></mat-icon>
                </button>
            </div>

        </div>
        <div class="col-span-2 md:col-span-1 md:mt-12">
            <div class="max-w-100 w-full mx-auto">
                <h4 class="text-4xl mt-4">No account yet?</h4>
                <div class="p-4 mb-4 rounded-lg bg-primary text-white border-l-4 dark:border-primary-300 border-primary-900">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <i class="ti ti-shield-check-filled text-white text-3xl"></i>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-xl font-medium">Create your account in <b>28 seconds</b>.</h3>
                            <div class="my-2 text-base">
                                <ul role="list" class="list-disc pl-5 py-2 space-y-1">
                                    <li>Track your projects and markouts</li>
                                    <li>Manage your team</li>
                                    <li>Test for free!</li>
                                </ul>
                            </div>

                            <button [routerLink]="'/register'" class="w-full" mat-flat-button >
                                Create account now!
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>